import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Profile() {
  const { refresh } = useAuth();
  const [p, setP] = useState(null);
  const [name, setName] = useState("");
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/customer/profile").then((r) => { setP(r.data); setName(r.data.name); }).catch(() => {}); }, []);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const payload = { name };
      if (pw.new_password) { payload.current_password = pw.current_password; payload.new_password = pw.new_password; }
      await api.put("/customer/profile", payload);
      toast.success("Profile updated"); setPw({ current_password: "", new_password: "" }); refresh();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (!p) return <div className="text-slate-400">Loading…</div>;

  return (
    <div className="max-w-xl space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Profile</h1>
      <form onSubmit={save} className="bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Email</span>
          <input disabled value={p.email} className="mt-1.5 w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50 text-slate-500" />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Full name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} data-testid="profile-name-input"
            className="mt-1.5 w-full px-4 py-2.5 rounded-xl border border-slate-300 outline-none focus:border-blue-500" />
        </label>
        <div className="border-t border-slate-200 pt-4">
          <div className="text-sm font-semibold text-slate-700 mb-3">Change password</div>
          <div className="space-y-3">
            <input type="password" placeholder="Current password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })}
              data-testid="profile-current-password" className="w-full px-4 py-2.5 rounded-xl border border-slate-300 outline-none" />
            <input type="password" placeholder="New password (min 8)" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })}
              data-testid="profile-new-password" className="w-full px-4 py-2.5 rounded-xl border border-slate-300 outline-none" />
          </div>
        </div>
        <button disabled={busy} data-testid="profile-save-button" className="px-5 py-2.5 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition disabled:opacity-60 inline-flex items-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Save changes
        </button>
      </form>
    </div>
  );
}
